import UserWrapper from './UserWrapper';

export default UserWrapper;
